import { BusinessEventDetailsValueType } from '../../models/BusinessEvent'
import { SyncStatus } from '../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/models'
import { IntegrationServiceId } from '../../common/integrations'

export const getBusinessEventDetailsDisplayValue = (value: BusinessEventDetailsValueType): string | number => {
  if (value === null) {
    return '-'
  }

  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== null)
      .map(getBusinessEventDetailsDisplayValue)
      .join(', ')
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }

  if (typeof value === 'number') {
    return value.toLocaleString('en-US')
  }

  return value
}

export const getSyncStatusServiceIdMapping = (syncStatuses: SyncStatus[]): Record<IntegrationServiceId, boolean> =>
  syncStatuses.reduce(
    (result, { serviceId, metadata, externalId }) => ({
      ...result,
      [serviceId]: result[serviceId] || metadata?.status === 'success' || (metadata?.status !== 'failed' && !!externalId),
    }),
    {} as Record<IntegrationServiceId, boolean>,
  )
